export const ECCO_ICON_NAMES = [
    "3d-image",
    "account",
    "ai-shoe",
    "arrow-back",
    "arrow-left",
    "arrow-newsletter-signup",
    "arrow-right",
    "backspace",
    "bag",
    "bell",
    "bin",
    "care",
    "chevron",
    "chevron-left",
    "chevron-light",
    "chevron-right",
    "clean",
    "close",
    "delivery-package",
    "discounts",
    "down",
    "facebook",
    "favorite",
    "filter",
    "filters",
    "finder",
    "help",
    "home",
    "info",
    "instagram",
    "kakaotalk",
    "line",
    "live-chat",
    "loading",
    "menu",
    "minus",
    "mute",
    "navigation",
    "ok",
    "passwordhide",
    "passwordshow",
    "pause",
    "pinterest",
    "play",
    "plus",
    "profile",
    "protect",
    "returns",
    "right",
    "ruler",
    "search",
    "star-empty",
    "star-filled",
    "star-partially",
    "store-locator",
    "tag",
    "tiktok",
    "truck",
    "tryandbuy",
    "user-check",
    "virtual-try-on",
    "volume",
    "wechat",
    "wishlist",
    "wishlist-filled",
    "youtube",
] as const;

export type ECCOIconName = (typeof ECCO_ICON_NAMES)[number];

const iconNames: ReadonlySet<string> = new Set(ECCO_ICON_NAMES);

export function isECCOIconName(name: unknown): name is ECCOIconName {
    return typeof name === "string" && iconNames.has(name);
}
